import { Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';

@Component({
  selector: 'smart-manage-thing-filter',
  templateUrl: './manage-thing-filter.component.html',
  styleUrls: ['./manage-thing-filter.component.scss', '../../platform-color/platform-color.css']
})
export class ManageThingFilterComponent implements OnInit {
  form: FormGroup;
  @Input()
  filter: any;
  submitted: boolean = false;
  tab: string = "filter";
  messageError: string = "ไม่พบข้อมูลกรุณาตรวจสอบ Thing Key และ Thing Secret ของท่าน";

  ThingInfo = null;
  @Output() done = new EventEmitter<any>();
  @ViewChild("closeModal") private closeModal: ElementRef;
  constructor(
    private formBuilder: FormBuilder,
    private FarmService: FarmService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (
      changes.filter
    ) {
      this.ngOnInit();
    }
  }

  createForm() {
    // 9213547200134
    // 921354720013499
    this.form = this.formBuilder.group({
      thing_key: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9_.-]*$")]],
      thing_secret: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9_.-]*$")]],
    });
  }

  get f() {
    return this.form.controls;
  }

  check() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    };
    this.spinner.show();
    let filter = {
      thing_key: this.form.value.thing_key
    }
    this.FarmService.getThingMenuMGL(filter).subscribe(res => {
      if (res.data) {
        this.ThingInfo = res.data.ThingInfo[0];

        if (this.ThingInfo) {
          if (this.ThingInfo.ThingSecret == this.form.value.thing_secret) {

            this.tab = "success";
          } else {
            this.tab = "error";
          }
        } else {
          this.tab = "error";
        }
        this.submitted = false;
        this.spinner.hide();
      } else {
        this.submitted = false;
      }
    })
  }

  save() {

    this.spinner.show();
    if (this.form.value.thing_key) {
      let filter = {
        thing_id: this.ThingInfo.ThingId
      }
      this.FarmService.getThingByThingId(filter).subscribe(res => {
        if (res.code == 200) {
          let thingData = res.data;
          if (res.data.farms.find(farm => farm.farm_id != this.filter.farm_id)) {
            this.tab = "error";
            this.messageError = "ไม่สามารถเพิ่มอุปกรณ์ได้ เนื่องจากอุปกรณ์นี้มีการใช้งานอยู่แล้ว ในฟาร์มอื่น";
            this.spinner.hide();
          } else {
            let filter = {
              thing_id: this.ThingInfo.ThingId,
              plot_id: this.filter.plot_id,
            }
            this.FarmService.getThingByThingId(filter).subscribe(res => {
              if (res.code == 200) {
                this.done.emit(
                  {
                    ...this.ThingInfo
                  }
                );

                this.closeModal.nativeElement.click();
                this.close();

                this.spinner.hide();
              } else {
                if (thingData) {
                  thingData.thing_key = this.ThingInfo.ThingIdentifier;
                  thingData.plots.push(
                    {
                      plot_id: this.filter.plot_id,
                    }
                  )

                  this.FarmService.updateThing(thingData).subscribe(res => {
                    if (res.code == 200) {
                      this.done.emit(
                        {
                          ...this.ThingInfo
                        }
                      );
                      this.closeModal.nativeElement.click();
                      this.close();
                      this.spinner.hide();
                    }
                  })
                }
                this.spinner.hide();
              }
            })
          }
        } else {
          let data = {
            org_id: sessionStorage.getItem('Org'),
            child_org_id: sessionStorage.getItem('ChildOrg'),
            thing_key: this.ThingInfo.ThingIdentifier,
            thing_id: this.ThingInfo.ThingId,
            thing_name: this.ThingInfo.ThingName,
            thing_desc: this.ThingInfo.ThingDescription,
            thing_token: this.ThingInfo.ThingToken,
            account_id: this.ThingInfo.AccountId,
            imei: this.ThingInfo.IMEI,
            thing_secret: this.ThingInfo.ThingSecret,
            farms: [
              {
                farm_id: this.filter.farm_id
              }
            ],
            plots: [
              {
                plot_id: this.filter.plot_id
              }
            ]
          }

          this.FarmService.createThing(data).subscribe(res => {
            if (res.code == 200) {
              this.done.emit(
                {
                  ...this.ThingInfo
                }
              );
              this.closeModal.nativeElement.click();
              this.close();
              this.spinner.hide();
            }
          })
        }
      })
    }
  }

  close() {
    this.createForm();
    this.submitted = false;
    this.tab = "filter";
    this.messageError = "ไม่พบข้อมูลกรุณาตรวจสอบ Thing Key และ Thing Secret ของท่าน";
  }
}
